<div class="filter-wrapper">
    <div class="filter-facets-wrapper">
        <div class="store-stock-facet-wrapper">
            <app-store-stock-facet
                [disabled]="storeStockDisabled"
                (filterByStoreChange)="facetUpdate.emit($event)"
            ></app-store-stock-facet>
        </div>
        <div class="same-day-facet-wrapper" *appSameDayDeliveryInOffMode>
            <app-same-day-delivery-facet
                (sameDayDeliveryChange)="onSameDayDeliveryChange($event)"
            ></app-same-day-delivery-facet>
        </div>
    </div>
</div>
<div class="filter-overflow-wrapper" [ngClass]="{ 'filter-overflow-wrapper-expanded': expanded }">
    <div class="filter-facets-wrapper">
        <div class="filter-select-wrapper">
            <div
                class="filter-select"
                [ngClass]="{ 'filter-select-toned': activeKey !== null && activeKey !== facetGroup.key }"
                *ngFor="
                    let facetGroup of facetGroups
                        | facetGroupsWithValues
                        | slice: 0:(expanded ? infinity : maxVisibleFacets);
                    let index = index;
                    trackBy: trackFacetFn
                "
            >
                <app-filter-select
                    [facetGroup]="facetGroup"
                    (expandUpdate)="onExpandUpdate($event, facetGroup.key)"
                    (facetUpdate)="onFacetUpdate($event)"
                ></app-filter-select>
            </div>
        </div>
        <div class="show-more-overflow-wrapper">
            <div class="show-more-button-wrapper" *ngIf="facetGroups">
                <button
                    class="kk-icon-btn show-more-button"
                    [ngClass]="{ mark: expanded }"
                    (click)="expanded = !expanded"
                >
                    {{
                        (expanded ? 'filter.buttonText.showLessFilters' : 'filter.buttonText.showMoreFilters')
                            | translateSafe
                    }}
                    <span class="arrow-icon">
                        <app-svg-icon iconName="chevron_down"></app-svg-icon>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
